import { MAGAZINE_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const AdminMagazineService = {
  getAll: (params: any) => requests.get(`${MAGAZINE_URL}`, params),
  create: (params: any) => requests.post(`${MAGAZINE_URL}`, params),
  getSingle: (id: number) => requests.get(`${MAGAZINE_URL}/${id}`),
  update: (params: any, id: number) =>
    requests.put(`${MAGAZINE_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${MAGAZINE_URL}/${id}`),
  updatePosition: (params: any) => requests.patch(`${MAGAZINE_URL}`, params),
};
